import { Tag } from 'antd'

import { TreatmentPlanStatus, TreatmentPlanStatus2 } from 'src/api/requests'
import { useLocales } from 'src/locales'

type Props = {
  status?: TreatmentPlanStatus | TreatmentPlanStatus2
}

const TreatmentsStatusMap = {
  [TreatmentPlanStatus.CANCELLED]: 'error',
  [TreatmentPlanStatus.COMPLETED]: 'success',
  [TreatmentPlanStatus.IN_PROGRESS]: 'warning',
  [TreatmentPlanStatus.NEW]: 'processing'
}

export const TreatmentStatusTag = ({ status }: Props) => {
  const { t } = useLocales()

  if (!status) return '-'

  const color = TreatmentsStatusMap[status]

  return <Tag color={color}>{t(`treatments.${status}`)}</Tag>
}
